import React from "react";
import { NAVIGATE_TO } from "../../../../constants/FileConstants";
import { SandboxAccessData } from "../../../../constants/StepperData";
import CodeBlock from "../../../../shared/CodeBlock/CodeBlock";
import Endpoints from "../../../../shared/Endpoints/Endpoints";
import Stepper from "../../../../shared/Stepper/Stepper";
import { TextContent } from "../../../../shared/TextContent/TextContent";
import SupportedDataAccess from "../StepComponents/SupportedDataAccess";

function SandboxAccess() {
  return (
    <section className="subgroup" id="sandbox-access-section">
      <TextContent
        header={"Sandbox Access"}
        description={
          "Try out our open access registration application to interact with sample FHIR data directly from your web browser."
        }
      />
      <div className="step-container">
        <div className="number-and-title">
          <h2 className="step-number">1</h2>
          <h2 className="step-title">Registration</h2>
        </div>
        <ul className="step-content">
          <li>
            <p>
              HealthOS FHIR Application Programming Interface (API) provides a
              uniform way for patients and clinicians to access health data
              using the{" "}
              <a target="_blank" href="https://hl7.org/fhir/">
                HL7 Fast Healthcare Interoperability Resources (FHIR) standard.
              </a>
            </p>
          </li>
          <li>
            <p>
              Utilize our{" "}
              <a href={NAVIGATE_TO.PROD_SB_ENTITY_REGISTRATION} target="_blank">
                Sandbox Registration Link
              </a>{" "}
              to easily create a sandbox test account.
            </p>
          </li>
          <li>
            <p>
              Register your applications seamlessly through our entity
              registration portal.
            </p>
          </li>
          <li>
            <p>
              To initiate the registration process and acquire credentials, the
              user must register an entity. Once the entity is approved, the
              user will be shown the client ID, client secret, token, and FHIR
              URL to proceed further.
            </p>
          </li>
          <li>
            <p>
              Utilize the client ID and secret in future authenticated API
              requests by including them in headers and parameters. To Follow
              the formats go through the below sections.
            </p>
          </li>
          <li>
            <p>
              We require PKCE (Proof key for code exchange) as an additional level of security, Clients should include code_challenge and code_challenge_method in the authorization request and provide corresponding code_verifier  when exchanging the authorization code for token.
            </p>
          </li>
        </ul>
      </div>
      {/* <SupportedDataAccess
                accessType={"sandbox"}
                patientAccess={true}
                pdex={true}
                stepNumber={2}
                sandbox={true} /> */}
    </section>
  );
}

export default SandboxAccess;
